import { shallowMount } from "@vue/test-utils";
import StepCounter from "@/components/core/StepCounter";

describe("StepCounter component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(StepCounter, {
      mocks: {
        config: {
          cantPasos: 8
        }
      }
    });
  });

  it("Renders del component StepCounter", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
